import { Popup } from '../common/popup/Popup';

export const CasparCGExporterSettings = () => {
  return (
    <Popup id="casparcgExporterSettings" title="CasparCG Export Settings">
      Settings will be here...
    </Popup>
  );
};
